export const BOARD_CERTIFICATION_STATUS_OPTIONS = [
  {
    value: 1,
    text: 'Certified',
  },
  {
    value: 0,
    text: 'Eligible',
  },
];

export const alphanumericallyKeyComparator = (a,b, key = 'title') => {
  if ( a[key] < b[key] ){
    return -1;
  }
  if ( a[key] > b[key] ){
    return 1;
  }
  return 0;
};
